var map = {
	"./setUp0.png": "if39",
	"./setUp1.png": "tfT2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UDjd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/setUp.*\.png$
// module id = UDjd
// module chunks = 3